import {Fragment, h} from 'preact';
import ServiceInfo from "./ServiceInfo";

export default function ServiceRow({contract, account, amounts, onChangeCheckbox, isChecked, onChangeAmountInput, formParams, createOrderForContract, checkFineForContract, isFineChecked}){
	const {meterDevices} = contract;
	let canEnterMeterReadings = true;
	let enterUrl = null;
	let workingDevices = false;
	meterDevices.map(device => {
		if(device.canEnterMeterReadings) {
			enterUrl = device.enterUrl;
		} else {
			canEnterMeterReadings = false;
		}
		if(device.stateStatus == 'working')
		{
			workingDevices = true;
		}
	});

	let enterMeterDisabledButtonText = 'Прибор учета неисправен или отсутствует';
	if(!canEnterMeterReadings && workingDevices)
	{
		enterMeterDisabledButtonText = 'Показания были внесены сегодня';
	}

	const columnTitleClass = isChecked ? 'form-field__input-row form-field__input-row_ai_center':'';

	return (
		<Fragment>
			{!contract.isClosed > 0
			&& <ServiceInfo
				canEnterMeterReadings={canEnterMeterReadings}
				enterUrl={enterUrl}
				contract={contract}
				account={account}
				formParams={formParams}
				amounts={amounts}
				createOrderForContract={createOrderForContract}
				onChangeAmountInput={onChangeAmountInput}
				enterMeterDisabledButtonText={enterMeterDisabledButtonText}
				checkFineForContract={checkFineForContract}
				isFineChecked={isFineChecked}
			/>}
			{!!contract.isClosed && (
				<div className="debt-table-item-2 debt-table__item">
					<div className="debt-table-item-2__row">
						<div className="debt-table-item-2__col"/>
						<div className="debt-table-item-2__col debt-table-item-2__col_fg_1">
							<div className="debt-table-item-2__text">
								Передача показаний невозможна, с {contract.closeDate} договор расторгнут
							</div>
						</div>
					</div>
				</div>
			)}
		</Fragment>
	);
}
